import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ComponentBase} from "../component-base/component-base.component";
import {NgClassType} from "../../model/common.model";
import {ThemePalette} from "@angular/material/core";
import {NgClass, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";



export type GenericButtonType = 'mat-raised-button' | 'mat-icon-button' | 'native-link'

@Component({
  selector: 'generic-button',
  standalone: true,
  imports: [
    NgClass,
    NgSwitch,
    NgSwitchCase,
    MatIconModule,
    MatButtonModule,
    NgSwitchDefault,
    NgIf
  ],
  templateUrl: './generic-button.component.html',
})
export class GenericButtonComponent extends ComponentBase {

  @Input() buttonNgClass: NgClassType
  @Input() buttonTitle?: string = undefined
  @Input() buttonType: GenericButtonType = 'mat-raised-button'
  @Input() iconNgClass?: NgClassType
  @Input() iconKey?: string = undefined
  @Input() color: ThemePalette
  @Input() disabled?: boolean
  @Output() buttonClick = new EventEmitter<any>()

  constructor() {
    super()
  }

  onClick(ev: any): void {
    if (!this.disabled) {
      this.buttonClick.emit(ev)
    }
  }
}
